/**
 * Lightweight field-level validators.
 * Each returns an error string or '' (no error).
 */

/** Indian mobile: 10 digits, starts 6–9. Also accepts empty (field optional). */
export function validatePhone(value: string): string {
  if (!value.trim()) return '';
  const digits = value.replace(/[\s\-().+]/g, '');
  if (!/^[6-9]\d{9}$/.test(digits))
    return 'Enter a valid 10-digit Indian mobile number (starts with 6–9)';
  return '';
}

/** Basic email format. Empty = no error (field optional). */
export function validateEmail(value: string): string {
  if (!value.trim()) return '';
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim()))
    return 'Enter a valid email address';
  return '';
}

/** Zipcode: 6 digits. Empty = no error. */
export function validateZipcode(value: string): string {
  if (!value.trim()) return '';
  if (!/^\d{6}$/.test(value.trim())) return 'Zipcode must be 6 digits';
  return '';
}

/** Generic required field. */
export function validateRequired(value: string, label: string): string {
  return value.trim() ? '' : `${label} is required`;
}
